import React, { useState } from 'react';
import { Button, Col, Form, Input, Row, Upload, message } from 'antd';

import AntIcon from '../../shared/components/AntIcon';
import { formItemLayout, getValidationState, wrapFormItemInput } from '../../shared/utils/form_components';
import { uploadGiveawayBanner, getApiErrorMessage } from '../api';

/**
 * redux-form Field component: text URL + multipart upload to `/uploads/giveawayBanners` (field `image`).
 */
export default function BannerImageField(props) {
  const { input, meta, label, extra } = props;
  const [uploading, setUploading] = useState(false);

  const beforeUpload = (file) => {
    setUploading(true);
    uploadGiveawayBanner(file)
      .then((data) => {
        if (data && data.url) input.onChange(data.url);
        message.success('Banner uploaded');
      })
      .catch((err) => {
        message.error(getApiErrorMessage(err, 'Banner upload failed'));
      })
      .finally(() => setUploading(false));
    return false;
  };

  const id = `${meta.form}_${input.name}`;
  const value = input.value == null ? '' : String(input.value);

  return (
    <Form.Item
      {...formItemLayout}
      label={label}
      extra={extra}
      validateStatus={getValidationState(meta)}
      help={meta.touched ? meta.error : null}
    >
      <Row gutter={8} type="flex" align="middle">
        <Col xs={24} sm={14}>
          {wrapFormItemInput(
            <Input {...input} id={id} placeholder="https://… or upload a file" />,
          )}
        </Col>
        <Col xs={24} sm={10}>
          <Upload accept="image/*" showUploadList={false} beforeUpload={beforeUpload}>
            <Button htmlType="button" loading={uploading}>
              <AntIcon type="upload" /> Upload
            </Button>
          </Upload>
        </Col>
      </Row>
      {value && /^https?:\/\//i.test(value) && (
        <div style={{ marginTop: 8 }}>
          <img
            src={value}
            alt="Banner preview"
            style={{ maxWidth: '100%', width: 'auto', maxHeight: 140, objectFit: 'contain', borderRadius: 4 }}
            referrerPolicy="no-referrer"
          />
        </div>
      )}
    </Form.Item>
  );
}
